import { useCallback } from 'react';

import type { LegendItem } from '../../core/components/legend/categorical/types/legend.js';
import { useTooltipReducer } from '../../core/components/overlay-tooltip/useTooltipReducer.js';
import { useSetState } from '../store/selectors.js';
import type { TreeMapState } from '../types/state.js';

/**
 * Hook that generates the corresponding handlers to interact with the Treemap
 * @returns Handlers to interact with the Treemap nodes
 */
export function useTreeMapHandlers() {
  const setState = useSetState();
  const dispatch = useTooltipReducer();

  const onLegendItemHover = useCallback(
    (item: LegendItem | undefined): void => {
      setState((prev: TreeMapState) => ({
        ...prev,
        highlightedItem: item,
      }));
    },
    [setState],
  );

  const onLegendItemClick = useCallback(
    (items: LegendItem[]): void => {
      dispatch({ type: 'RESET_TOOLTIP' })();
      setState((prev: TreeMapState) => ({
        ...prev,
        groupsSelected: items,
      }));
    },
    [setState, dispatch],
  );

  return { onLegendItemHover, onLegendItemClick };
}
